import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";

import { getIcon } from "../../../helpers/icons";
import Card from "./Card";
import NotificationCount from "./Count"
import Link from "../../../components/Link";
import Spacer from "../../../components/Spacer";
import Spinner from "../../../components/Spinner";
import ClearNotification from "./ClearNotification";
import List from "../../../components/Materials/List";

import style from "./style.module.css";
import Text from "../../../components/Text";
import WithPermission from "../../Shared/WithPermission";

const Notification = ({ isNotificationOpen, toggleNotification = () => { } }) => {
    const notificationData = useSelector((state) => get(state.grid, "NotificationList", {}));
    const { list = [], fetching } = notificationData;
    return (
        <div className={`${style.notification}${isNotificationOpen ? " " + style.active : ""}`}>
            <Link className={style.icon} onClick={toggleNotification} >
                <i className={getIcon(isNotificationOpen ? "Bellsolid" : "Bell")} />
                <NotificationCount isNotificationOpen={isNotificationOpen} />
            </Link>
            {
                isNotificationOpen && (
                    <div className={`${style.notificationDropdown}${(list.length === 0 && fetching === false) ? ` ${style.emptyNotification}` : ``}`}>
                        {list.length === 0 && fetching === false &&
                            <>
                                <Text className="size14">You have no new notifications.</Text>
                            </>
                        }
                        {list.length > 0 &&
                            <WithPermission permission="Notification Delete All">
                                <ClearNotification toggleNotification={toggleNotification} />
                            </WithPermission>
                        }
                        <List
                            url="notification"
                            attribute="NotificationList"
                            loadOnMount={true}
                            showSearchParamsInUrl={false}
                            canShowNoResult={false}
                            permissionText="Notification List"
                            itemTemplate={(item) => {
                                return (
                                    <Card item={item} toggleNotification={toggleNotification} />
                                );
                            }}
                            skeleton={
                                <div className={style.loading}>
                                    <Spacer />
                                    <Spinner />
                                    <Spacer />
                                </div>
                            }
                            infiniteScrollElement={list.length > 0 && fetching === false ? `.${style.notificationDropdown}` : window}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default Notification;
